<template>
  <div :class="{
    'c-sidebar': true,
    'is-active': index > 0
  }">
    <div class="c-sidebar__nav">
      <div :class="{
        'c-sidebar__item': true,
        'is-active': n  === index
      }" v-for="n in 14" :key="n" @click.prevent="goToSlide(n)">
        <span v-if="n < 13" class="c-sidebar__item-count">
          {{ n }} / 12
        </span>
        <span v-else-if="n === 13" class="c-sidebar__item-count">
          {{ afterword.sidebar }}
        </span>
        <span v-else class="c-sidebar__item-count">
          {{ globals.share_label }}
        </span>
        <span class="c-sidebar__item-icon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Sidebar',
  props: ['index'],

  methods: {
    goToSlide (n) {
      const index = n + 1
      this.$root.$emit('goToSlide', { index })
    }
  },

  computed: mapState({
    lang: state => state.language,
    globals (state) {
      const lang = this.lang
      return state.translations.general[lang]
    },
    afterword (state) {
      const lang = this.lang
      return state.translations.afterword[lang]
    }
  })
}
</script>
